import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { HoverText } from '@campfire/hover-link';
import { useFormBuilderDialogContext } from '../FormBuilderDialogContext';
import { GetForm_vm_form_formItems_VOLUNTEER_FormItemMediaType as MediaFormItemType } from '../../__generated__/GetForm';

interface Props {
  data: MediaFormItemType;
}

export const MediaFormItem = (props: Props) => {
  const { data } = props;
  const { editMedia } = useFormBuilderDialogContext();

  return (
    <Grid container spacing={1} style={{ padding: 24 }}>
      <Grid item xs>
        <Typography variant='body2' color='textSecondary'>
          {`Media: ${data.media?.name || 'Untitled'}`}
        </Typography>
      </Grid>
      <Grid item>
        <HoverText color='primary' onClick={() => editMedia(data)}>
          {'Edit media'}
        </HoverText>
      </Grid>
    </Grid>
  );
};
